import moment from "moment";
export const Mydata = {
  data() {
    return {
      timeType: [{ id: "1", title: "日" }],
      apps: [],
      systemIds: [
        { id: "1", title: "Android" },
        { id: "2", title: "ios" },
      ],
      adtypemine_id: [],
      adpositionid_id: [],
      ad_platform: [],
      numberArr: [],
      nameArr: [
        "点击率",
        "安卓下载开始率",
        "安卓下载完成率",
        "安卓安装完成率",
        "激活率",
        "首次付费率",
        "99%进度播放率",
        "25%进度播放率",
        "50%进度播放率",
        "75%进度播放率",
        "播放10s率",
        "播放5s率",
        "播放3s率",
        "播放2s率",
        "播放完成率",
        "次留率",
      ],
      // 需要处理百分比的字段
      keyArr: [
        "convert_rate",
        "ctr",
        "download_start_rate",
        "download_finish_rate",
        "install_finish_rate",
        "active_rate",
        "active_pay_rate",
        "play_100_feed_break_rate",
        "play_75_feed_break_rate",
        "play_50_feed_break_rate",
        "play_25_feed_break_rate",
        "play_duration_10s_rate",
        "play_duration_5s_rate",
        "play_duration_3s_rate",
        "play_duration_2s_rate",
        "play_over_rate",
        "event_next_day_stay_ratio",
        "roi_day_1",
        "roi_day_2",
        "roi_day_3",
        "roi_day_4",
        "roi_day_5",
        "roi_day_6",
        "roi_day_7",
        "roi_day_14",
        "roi_day_30",
        "roi_day_33",
        "roi_day_60",
        "roi_day_63",
        "roi_day_67",
        "roi_day_90",
        "roi_day_180",
        "roi_day_365",
        "renew_num_day_scale_1",
        "renew_num_day_ratio_1",
        "renew_num_day_ratio_3",
        "renew_num_day_ratio_7",
        "renew_num_day_ratio_33",
        "renew_num_day_ratio_37",
        "renew_num_day_ratio_63",
        "renew_num_day_ratio_67",
        "renew_num_day_ratio_93",
        "renew_num_day_ratio_97",
      ],
      // 需要处理千分位的字段
      numKeyArr: [
        "cost",
        "show",
        "click",
        "avg_show_cost",
        "download_start",
        "download_finish",
        "install_finish",
        "active",
        "active_pay_cost",
        "play_100_feed_break",
        "play_75_feed_break",
        "play_50_feed_break",
        "play_25_feed_break",
        "play_duration_10s",
        "play_duration_3s",
        "play_duration_2s",
        "play_duration_sum",
        "total_play",
        "play_over",
        "like",
        "comment",
        "custom",
        "event_next_day_stay",
        "new_add",
        "recovery_amount_day_1",
        "recovery_amount_day_2",
        "recovery_amount_day_3",
        "recovery_amount_day_4",
        "recovery_amount_day_5",
        "recovery_amount_day_6",
        "recovery_amount_day_7",
        "recovery_amount_day_14",
        "recovery_amount_day_30",
        "recovery_amount_day_33",
        "recovery_amount_day_60",
        "recovery_amount_day_63",
        "recovery_amount_day_67",
        "recovery_amount_day_90",
        "recovery_amount_day_180",
        "recovery_amount_day_365",
        "renew_num_day_1",
        "renew_num_day_3",
        "renew_num_day_7",
        "renew_num_day_33",
        "renew_num_day_63",
        "renew_num_day_67",
        "renew_num_day_93",
        "renew_num_day_97",
        "renew_num_day_spent_1",
        "renew_num_day_spent_3",
        "renew_num_day_spent_7",
        "renew_num_day_spent_33",
        "renew_num_day_spent_37",
        "renew_num_day_spent_63",
        "renew_num_day_spent_67",
        "renew_num_day_spent_93",
        "renew_num_day_spent_97",
      ],
      // 需要保留整数的字段
      reservedInteger:[
        "pay_count",
        "show",
        "click",
        "download_start",
        "download_finish",
        "install_finish",
        "active",
        "play_100_feed_break",
        "play_75_feed_break",
        "play_50_feed_break",
        "play_25_feed_break",
        "play_duration_10s",
        "play_duration_3s",
        "play_duration_2s",
        "total_play",
        "play_over",
        "like",
        "comment",
        "share",
        "event_next_day_stay",
        "new_add",
        "renew_num_day_1",
        "renew_num_day_3",
        "renew_num_day_7",
        "renew_num_day_33",
        "renew_num_day_37",
        "renew_num_day_63",
        "renew_num_day_67",
        "renew_num_day_93",
        "renew_num_day_97",
      ],
      ad_id: [],
      title: [],
      app_key_oth: [],
      comparison_data: [
        {
          title: "指标对比",
          value: 1,
        },
        {
          title: "维度对比",
          value: 2,
        },
        {
          title: "时间对比",
          value: 3,
        },
      ],
      dimension: [
        {
          label: "日期",
          prop: "date",
          value: 1000,
          sortable:"custom"
        },
        {
          label: "项目",
          prop: "project",
          value: 1001,
        },
        {
          label: "应用",
          prop: "app_title",
          value: 1002,
        },
        {
          label: "系统",
          prop: "system_title",
          value: 1003,
        },
        // {
        //   label: "投放平台",
        //   prop: "platform",
        //   value: 1004,
        // },
        {
          label: "投放渠道",
          prop: "channel",
          value: 1005,
        },
        {
          label: "素材id",
          prop: "material_id",
          value: 1006,
        },
      ],
      column: [
        {
          label: "日期",
          prop: "date",
        },
        {
          label: "项目",
          prop: "project",
        },
        {
          label: "应用",
          prop: "app_title",
        },
        {
          label: "系统",
          prop: "system_title",
        },
        {
          label: "投放平台",
          prop: "platform",
        },
        {
          label: "投放渠道",
          prop: "channel",
        },
        {
          label: "视频",
          prop: "material_id",
        },
        {
          label: "总花费",
          prop: "cost",
          sortable: "custom",
          width: "100",
        },
        {
          label: "曝光数",
          prop: "show",
          sortable: "custom",
          width: "100",
        },
        {
          label: "点击数",
          prop: "click",
          sortable: "custom",
          width: "100",
        },
        {
          label: "点击率",
          prop: "ctr",
          width: "100",
        },
        {
          label: "平均点击单价",
          prop: "avg_click_cost",
          width: "120",
        },
        {
          label: "平均千次展现费用",
          prop: "avg_show_cost",
          width: "150",
        },
        {
          label: "安卓下载开始数",
          prop: "download_start",
          sortable: "custom",
        },
        {
          label: "安卓下载开始成本",
          prop: "download_start_cost",
          width: "150",
        },
        {
          label: "安卓下载开始率",
          prop: "download_start_rate",
          width: "135",
        },
        {
          label: "安卓下载完成数",
          prop: "download_finish",
          sortable: "custom",
        },
        {
          label: "安卓下载完成成本",
          prop: "download_finish_cost",
          width: "150",
        },
        {
          label: "安卓下载完成率",
          prop: "download_finish_rate",
          width: "135",
        },
        {
          label: "安卓安装完成数",
          prop: "install_finish",
          sortable: "custom",
        },
        {
          label: "安卓安装完成成本",
          prop: "install_finish_cost",
          width: "150",
        },
        {
          label: "安卓安装完成率",
          prop: "install_finish_rate",
          width: "135",
        },
        {
          label: "激活数",
          prop: "active",
          sortable: "custom",
          width: "100",
        },
        {
          label: "激活成本",
          prop: "active_cost",
          width: "100",
        },
        {
          label: "激活率",
          prop: "active_rate",
          width: "100",
        },
        {
          label: "首次付费次数",
          prop: "pay_count",
          sortable: "custom",
        },
        {
          label: "首次付费成本",
          prop: "active_pay_cost",
          width: "124",
        },
        {
          label: "首次付费率",
          prop: "active_pay_rate",
        },
        {
          label: "99%进度播放数",
          prop: "play_100_feed_break",
          sortable: "custom",
        },
        {
          label: "99%进度播放率",
          prop: "play_100_feed_break_rate",
          width: "150",
        },
        {
          label: "75%进度播放数",
          prop: "play_75_feed_break",
          sortable: "custom",
        },
        {
          label: "75%进度播放率",
          prop: "play_75_feed_break_rate",
          width: "150",
        },
        {
          label: "50%进度播放数",
          prop: "play_50_feed_break",
          sortable: "custom",
        },
        {
          label: "50%进度播放率",
          prop: "play_50_feed_break_rate",
          width: "150",
        },
        {
          label: "25%进度播放数",
          prop: "play_25_feed_break",
          sortable: "custom",
        },
        {
          label: "25%进度播放率",
          prop: "play_25_feed_break_rate",
          width: "150",
        },
        {
          label: "播放10s数",
          prop: "play_duration_10s",
          sortable: "custom",
        },
        {
          label: "播放10s率",
          prop: "play_duration_10s_rate",
          width: "110",
        },
        {
          label: "播放5s率",   // 巨量需要引擎删掉
          prop: "play_duration_5s_rate",
          width: "110",
        },
        {
          label: "播放3s数",
          prop: "play_duration_3s",
          sortable: "custom",
        },
        {
          label: "播放3s率",
          prop: "play_duration_3s_rate",
          width: "110",
        },

        {
          label: "播放2s数",
          prop: "play_duration_2s",
          sortable: "custom",
        },
        {
          label: "播放2s率",
          prop: "play_duration_2s_rate",
          width: "110",
        },
        {
          label: "总播放时长(单位s)",
          prop: "play_duration_sum",
          sortable: "custom",
        },
        {
          label: "总播放数",
          prop: "total_play",
          sortable: "custom",
        },
        {
          label: "播放完成数",
          prop: "play_over",
          sortable: "custom",
        },
        {
          label: "播放完成率",
          prop: "play_over_rate",
          width: "110",
        },
        {
          label: "点赞数",
          prop: "like",
          sortable: "custom",
        },
        {
          label: "评论数",
          prop: "comment",
          sortable: "custom",
        },
        {
          label: "分享数",
          prop: "share",
          sortable: "custom",
        },
        {
          label: "次留数",
          prop: "event_next_day_stay",
          sortable: "custom",
        },
        {
          label: "次留成本",
          prop: "event_next_day_stay_cost",
          width: "100",
        },
        {
          label: "次留率",
          prop: "event_next_day_stay_ratio",
          width: "85",
        },
        {
          label: "中台激活数",
          prop: "new_add",
        },
        {
          label: "1日回收",
          prop: "recovery_amount_day_1",
        },
        {
          label: "1日ROI",
          prop: "roi_day_1",
        },
        {
          label: "2日回收",
          prop: "recovery_amount_day_2",
        },
        {
          label: "2日ROI",
          prop: "roi_day_2",
        },
        {
          label: "3日回收",
          prop: "recovery_amount_day_3",
        },
        {
          label: "3日ROI",
          prop: "roi_day_3",
        },
        {
          label: "4日回收",
          prop: "recovery_amount_day_4",
        },
        {
          label: "4日ROI",
          prop: "roi_day_4",
        },
        {
          label: "5日回收",
          prop: "recovery_amount_day_5",
        },
        {
          label: "5日ROI",
          prop: "roi_day_5",
        },
        {
          label: "6日回收",
          prop: "recovery_amount_day_6",
        },
        {
          label: "6日ROI",
          prop: "roi_day_6",
        },
        {
          label: "7日回收",
          prop: "recovery_amount_day_7",
        },
        {
          label: "7日ROI",
          prop: "roi_day_7",
        },
        {
          label: "14日回收",
          prop: "recovery_amount_day_14",
        },
        {
          label: "14日ROI",
          prop: "roi_day_14",
        },
        {
          label: "30日回收",
          prop: "recovery_amount_day_30",
        },
        {
          label: "30日ROI",
          prop: "roi_day_30",
        },
        {
          label: "33日回收",
          prop: "recovery_amount_day_33",
        },
        {
          label: "33日ROI",
          prop: "roi_day_33",
        },
        {
          label: "60日回收",
          prop: "recovery_amount_day_60",
        },
        {
          label: "60日ROI",
          prop: "roi_day_60",
        },
        {
          label: "63日回收",
          prop: "recovery_amount_day_63",
        },
        {
          label: "63日ROI",
          prop: "roi_day_63",
        },
        {
          label: "67日回收",
          prop: "recovery_amount_day_67",
        },
        {
          label: "67日ROI",
          prop: "roi_day_67",
        },
        {
          label: "90日回收",
          prop: "recovery_amount_day_90",
        },
        {
          label: "90日ROI",
          prop: "roi_day_90",
        },
        {
          label: "180日回收",
          prop: "recovery_amount_day_180",
        },
        {
          label: "180日ROI",
          prop: "roi_day_180",
        },
        {
          label: "365日回收",
          prop: "recovery_amount_day_365",
        },
        {
          label: "365日ROI",
          prop: "roi_day_365",
        },
        {
          label: "首日订阅数",
          prop: "renew_num_day_1",
        },
        {
          label: "3日续订数",
          prop: "renew_num_day_3",
        },
        {
          label: "7日续订数",
          prop: "renew_num_day_7",
        },
        {
          label: "33日续订数",
          prop: "renew_num_day_33",
        },
        {
          label: "37日续订数",
          prop: "renew_num_day_37",
        },
        {
          label: "63日续订数",
          prop: "renew_num_day_63",
        },
        {
          label: "67日续订数",
          prop: "renew_num_day_67",
        },
        {
          label: "93日续订数",
          prop: "renew_num_day_93",
        },
        {
          label: "97日续订数",
          prop: "renew_num_day_97",
        },
        {
          label: "当日签约占比",
          prop: "renew_num_day_scale_1",
        },
        {
          label: "首日订阅购买率",
          prop: "renew_num_day_ratio_1",
        },
        {
          label: "3日续订率",
          prop: "renew_num_day_ratio_3",
        },
        {
          label: "7日续订率",
          prop: "renew_num_day_ratio_7",
        },
        {
          label: "33日续订率",
          prop: "renew_num_day_ratio_33",
        },
        {
          label: "37日续订率",
          prop: "renew_num_day_ratio_37",
        },
        {
          label: "63日续订率",
          prop: "renew_num_day_ratio_63",
        },
        {
          label: "67日续订率",
          prop: "renew_num_day_ratio_67",
        },
        {
          label: "93日续订率",
          prop: "renew_num_day_ratio_93",
        },
        {
          label: "97日续订率",
          prop: "renew_num_day_ratio_97",
        },
        {
          label: "订阅成本",
          prop: "renew_num_day_spent_1",
        },
        {
          label: "3日续订成本",
          prop: "renew_num_day_spent_3",
        },
        {
          label: "7日续订成本",
          prop: "renew_num_day_spent_7",
        },
        {
          label: "33日续订成本",
          prop: "renew_num_day_spent_33",
        },
        {
          label: "37日续订成本",
          prop: "renew_num_day_spent_37",
        },
        {
          label: "63日续订成本",
          prop: "renew_num_day_spent_63",
        },
        {
          label: "67日续订成本",
          prop: "renew_num_day_spent_67",
        },
        {
          label: "93日续订成本",
          prop: "renew_num_day_spent_93",
        },
        {
          label: "97日续订成本",
          prop: "renew_num_day_spent_97",
        },
      ],
      DashboardSetting: {
        basename: "",
        children: [],
      },
      pictLoading: false,
      sort: {
        prop: "",
        order: "",
      },
      checked: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近30天",
            onClick(picker) {
              const start = moment().subtract(1, "months").format("YYYY-MM-DD");
              const end = moment().format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近60天",
            onClick(picker) {
              const start = moment().subtract(2, "months").format("YYYY-MM-DD");
              const end = moment().format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近90天",
            onClick(picker) {
              const start = moment().subtract(3, "months").format("YYYY-MM-DD");
              const end = moment().format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const end = new Date();
              const years = end.getFullYear();
              const mouths = end.getMonth() + 1;
              const start = new Date(years + "-" + mouths + "-01");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              const preMonth = moment().subtract(1, "months").endOf("month");
              const end = preMonth.format("YYYY-MM-DD");
              const start = preMonth.format("YYYY-MM-01");
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 3600 * 1000;
        },
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 3600 * 1000;
        },
      },
      HMcolumn: [
        {
          label: "视频",
          prop: "date",
        },
        {
          label: "点击转化率环比增长",
          prop: "cycle",
        },
        {
          label: "消耗",
          prop: "cost",
        },
        {
          label: "点击率",
          prop: "ctr",
        },
        {
          label: "转化率",
          prop: "click_pay_rate",
        },
        {
          label: "转化成本",
          prop: "cost_pay_cost",
        },
      ],
    };
  },
};
